import React from "react";
import CategoryPage from "./CategoryPage";

const LaserEngravedWoodProducts = () => (
  <CategoryPage
    categoryId="laser-engraved-wood-products"
    categoryTitle="Laser Engraved Wood Products"
    categoryDescription="Premium laser-engraved wooden items for personalized gifts and home decor. Featuring intricate designs, natural wood finish, and exceptional craftsmanship. Perfect for special occasions."
  />
);

export default LaserEngravedWoodProducts;
